import { Form, Formik } from "formik";
import FormControl from "@mui/material/FormControl";
import { TextField, CircularProgress, Tabs, Tab, InputLabel, Select, MenuItem, Grid, Box } from "@mui/material";
import SearchComponent from "../../../components/OB/SearchComponent";
import TableComponent from "../../../components/OB/TableComponent";
import { useState, useEffect, useRef } from "react";
import KatalogBySorgulaAPI from "../../../apis/OB/Get/KatalogBySorgulaAPI";
import KatalogDilAPI from "../../../apis/OB/Get/KatalogDilAPI";
import KatalogKonusuAPI from "../../../apis/OB/Get/KatalogKonusuAPI";
import KatalogTipiAPI from "../../../apis/OB/Get/KatalogTipiAPI";
import KatalogYeriAPI from "../../../apis/OB/Get/KatalogYeriAPI";
import KutuphaneByCriteriaAPI, { KutuphaneByCriteriaRequest } from "../../../apis/OB/Get/KutuphaneByCriteriaAPI";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { showToast } from "../../../helpers/ToastifyHelper";
import * as Yup from "yup";
import dayjs, { Dayjs } from 'dayjs';


const validationSchema = Yup.object({
});


const KutuphaneKatalog: React.FC = () => {
    const [data, setData] = useState<any[]>([]);
    const [isSearched, setIsSearched] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState<string>('');
    const formikRef = useRef<any>(null);

    interface KatalogDilDto {
        dilKodu: string;
        dilAciklama: string;
    }
    interface KatalogTipDto {
        kodu: string;
        aciklama: string;
    }
    interface KatalogKonuDto {
        kodu: string;
        aciklama: string;
    }
    interface KatalogYerDto {
        kodu: string;
        aciklama: string;
    }
    interface KatalogOption {
        kodu: string;
        aciklama: string;
    }

    const [katalogDiller, setKatalogDiller] = useState<KatalogOption[]>([]);
    const [katalogTipleri, setKatalogTipleri] = useState<KatalogOption[]>([]);
    const [katalogKonular, setKatalogKonular] = useState<KatalogOption[]>([]);
    const [katalogYerler, setKatalogYerler] = useState<KatalogOption[]>([]);

    // katalog dili
    useEffect(() => {
        (async () => {
            setIsLoading(true);
            try {
                const response = await KatalogDilAPI.KatalogDil();
                const rawList = response.data as KatalogDilDto[];

                const mapped: KatalogOption[] = rawList.map(d => ({
                    kodu: d.dilKodu,
                    aciklama: d.dilAciklama
                }));

                setKatalogDiller(mapped);
            } catch (err) {
                console.error(err);
                setMessage('Katalog dil alınırken hata oluştu.');
            } finally {
                setIsLoading(false);
            }
        })();
    }, []);

    // katalog konusu
    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const response = await KatalogKonusuAPI.KatalogKonusu();
                console.log("konu", response);
                const rawList = response.data as KatalogKonuDto[];
                const mapped = rawList.map(k => ({
                    kodu: k.kodu,
                    aciklama: k.aciklama
                }));
                setKatalogKonular(mapped);
            } catch (err) {
                console.error(err);
                setMessage("Katalog konusu alınırken hata oluştu.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    // katalog tipi
    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const response = await KatalogTipiAPI.KatalogTipi();
                console.log("tip", response);
                const rawList = response.data as KatalogTipDto[];
                const mapped = rawList.map(t => ({
                    kodu: t.kodu,
                    aciklama: t.aciklama
                }));
                setKatalogTipleri(mapped);
            } catch (err) {
                console.error(err);
                setMessage("Katalog tipi alınırken hata oluştu.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    // katalog yeri
    useEffect(() => {
        (async () => {
            setIsLoading(true);
            try {
                const response = await KatalogYeriAPI.KatalogYeri();
                const rawList = response.data as KatalogYerDto[];

                const mapped: KatalogOption[] = rawList.map(d => ({
                    kodu: d.kodu,
                    aciklama: d.aciklama
                }));

                setKatalogYerler(mapped);
            } catch (err) {
                console.error(err);
                setMessage('Katalog dil alınırken hata oluştu.');
            } finally {
                setIsLoading(false);
            }
        })();
    }, []);

    const columns = [
        { header: "Kayıt No", field: "kayitNo", className: "text-center" },
        { header: "Eser Adı", field: "eserAdi", className: "text-center" },
        { header: "Yazar Adı", field: "yazarAdi", className: "text-center" },
        { header: "Yayınevi", field: "yayineviAdi", className: "text-center" },
        { header: "Barkod Kodu", field: "barkodKodu", className: "text-center" },
        { header: "Katalog Tipi", field: "katalogTipiAciklama", className: "text-center" },
        { header: "Katalog Türü", field: "katalogTuru", className: "text-center" },
        { header: "Katalog Konusu", field: "katalogKonuAciklama", className: "text-center" },
        { header: "Katalog Yeri", field: "katalogYerAciklama", className: "text-center" },
        { header: "Dil", field: "katalogDilAciklama", className: "text-center" },
        { header: "Basım Numarası", field: "basimNumarasi", className: "text-center" },
        { header: "Basım Tarihi", field: "basimTarihi", className: "text-center" },
        { header: "Genel Not", field: "genelNot", className: "text-center" },
        { header: "Yer Numarası", field: "yerNumarası", className: "text-center" },
        { header: "Kayıt Tarihi", field: "kayitTarihi", className: "text-center" },
        { header: "Kaydeden", field: "kaydeden", className: "text-center" },
        { header: "Adet", field: "adet", className: "text-center" },
        { header: "ISBN No", field: "isbnNo", className: "text-center" },
        { header: "KTH DYS ID1", field: "kthDysId1", className: "text-center" },
        { header: "KTH DYS ID2", field: "kthDysId2", className: "text-center" }
    ];


    const fetchData = async (values: KutuphaneByCriteriaRequest) => {
        setIsLoading(true);
        try {
            const res = await KutuphaneByCriteriaAPI.KutuphaneByCriteria(values);
            setData(res.data);
            setIsSearched(true);
        } catch (err) {
        } finally {
            setIsLoading(false);
        }
    };

    const handleTemizle = () => {
        setData([]);
        setIsSearched(false);
        formikRef.current?.resetForm();
    };


    return (
        <div className="px-1 px-md-2 px-lg-4 py-3 card w-100">
            <div className="card-body p-0" style={{ overflowX: "hidden" }}>
                <Formik
                    innerRef={formikRef}
                    initialValues={{
                        basimTarihiStart: null,
                        basimTarihiEnd: null,
                        eserAdi: '',
                        yazarAdi: '',
                        basimNumarasi: '',
                        yayinEvi: '',
                        katalogTipi: '',
                        katalogKonusu: '',
                        katalogDili: '',
                        barkodNumarasi: '',
                        katalogYeri: ''
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                        const basimTar = values.basimTarihiStart ? (values.basimTarihiStart as Dayjs).toDate() : undefined;
                        const basimTar2 = values.basimTarihiEnd ? (values.basimTarihiEnd as Dayjs).toDate() : undefined;

                        const payload = new KutuphaneByCriteriaRequest(
                            basimTar,
                            basimTar2,
                            values.basimNumarasi || undefined,
                            undefined,
                            values.eserAdi || undefined,
                            values.yazarAdi || undefined,
                            values.yayinEvi || undefined,
                            values.barkodNumarasi || undefined,
                            values.katalogTipi ? Number(values.katalogTipi) : undefined,
                            values.katalogYeri ? Number(values.katalogYeri) : undefined,
                            values.katalogKonusu ? Number(values.katalogKonusu) : undefined,
                            values.katalogDili ? Number(values.katalogDili) : undefined
                        );

                        fetchData(payload);
                    }}

                >
                    {({ values, setFieldValue, resetForm, handleSubmit, getFieldProps }) => (
                        <>
                            <Form id="kayit-form" className="w-100 mb-4">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                label="Basım Başlangıç"
                                                value={values.basimTarihiStart}
                                                onChange={(date) => setFieldValue('basimTarihiStart', date)}
                                                slotProps={{ textField: { size: 'small', fullWidth: true } }}
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                label="Basım Bitiş"
                                                value={values.basimTarihiEnd}
                                                onChange={(date) => setFieldValue('basimTarihiEnd', date)}
                                                slotProps={{ textField: { size: 'small', fullWidth: true } }}
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField
                                            label="Eser Adı"
                                            size="small"
                                            fullWidth
                                            {...getFieldProps('eserAdi')}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField
                                            label="Yazar Adı"
                                            size="small"
                                            fullWidth
                                            {...getFieldProps('yazarAdi')}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField
                                            label="Basım Numarası"
                                            size="small"
                                            fullWidth
                                            {...getFieldProps('basimNumarasi')}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField
                                            label="Yayın Evi"
                                            size="small"
                                            fullWidth
                                            {...getFieldProps('yayinEvi')}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Katalog Tipi</InputLabel>
                                            <Select
                                                label="Katalog Tipi"
                                                {...getFieldProps('katalogTipi')}
                                            >
                                                {katalogTipleri.map(t => (
                                                    <MenuItem key={t.kodu} value={t.kodu}>
                                                        {t.aciklama}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Katalog Konusu</InputLabel>
                                            <Select
                                                label="Katalog Konusu"
                                                {...getFieldProps('katalogKonusu')}
                                            >
                                                {katalogKonular.map(k => (
                                                    <MenuItem key={k.kodu} value={k.kodu}>
                                                        {k.aciklama}
                                                    </MenuItem>
                                                ))}
                                            </Select>

                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Katalog Dili</InputLabel>
                                            <Select
                                                label="Katalog Dili"
                                                {...getFieldProps('katalogDili')}
                                            >
                                                {katalogDiller.map(opt => (
                                                    // value ve içeriğe yalnızca string veriyoruz
                                                    <MenuItem key={opt.kodu} value={opt.kodu}>
                                                        {opt.aciklama}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField
                                            label="Barkod Numarası"
                                            size="small"
                                            fullWidth
                                            {...getFieldProps('barkodNumarasi')}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Katalog Yeri</InputLabel>
                                            <Select
                                                label="Katalog Yeri"
                                                {...getFieldProps('katalogYeri')}
                                            >
                                                {katalogYerler.map(k => (
                                                    <MenuItem key={k.kodu} value={k.kodu}>
                                                        {k.aciklama}
                                                    </MenuItem>
                                                ))}
                                            </Select>

                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Form>

                            <Box display="flex" justifyContent="flex-end" mt={3} mb={4}>
                                <SearchComponent fetchData={handleSubmit} onTemizle={handleTemizle} setData={setData} />
                            </Box>
                        </>
                    )}
                </Formik>

                {isLoading ? (
                    <div className="d-flex w-100 justify-content-center align-items-center" style={{ height: "10rem" }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <TableComponent columns={columns} data={data} recordsPerPage={10} isSearched={isSearched} />
                )}
            </div>
        </div>
    );
};

export default KutuphaneKatalog;
